import config from 'constants/config'
import Places from 'constants/places'
import { TrendingDestination } from 'home/components/TrendingDestinations/constants'
import { EmptyObject } from 'lib/object/objectUtils'
import { encodeSearchParams } from 'lib/search/searchUtils'
import { useMemo } from 'react'

const trendingPlaceToImageId = new Map<App.Place, string>([
  [Places.Bali, 'vg4uvt2y5dgkivujuba6'],
  [Places.Thailand, 'lids8h5rs9zj2xvkxr'],
  [Places.Australia, '6swob1q88xi45bmcm4lgm'],
  [Places.Italy, '105jinf6w80g48xz4m5i'],
  [Places.Greece, 'la8fpc5ehwxlh9cyd9ne'],
  [Places.Spain, '7mxbm2s01q38r2900zj'],
  [Places.France, 'n32e56two8igfwfrzvq'],
  [Places.UnitedKingdom, 'ro18bawi3c1q4ky0jl'],
  [Places.Croatia, '2og8mpyqh9ow3t73mupc'],
  [Places.Cyprus, '3qt6b13q1irs446v5r'],
])

const trendingPlaces = [
  Places.Bali,
  Places.Thailand,
  Places.Australia,
  Places.Italy,
  Places.Greece,
  Places.Spain,
  Places.France,
  Places.UnitedKingdom,
  Places.Croatia,
  Places.Cyprus,
]

export function useVillasTrendingDestinations(
  filters: App.OfferListFilters = EmptyObject,
): Array<TrendingDestination> {
  return useMemo(() => trendingPlaces.map(place => {
    const queryParams = encodeSearchParams({
      destinationId: place.id,
      destinationName: place.name,
      rooms: [config.search.defaultOccupants],
      filters,
      isFlexibleWithDate: true,
    }).toString()

    return {
      name: place.name,
      imageId: trendingPlaceToImageId.get(place) ?? '',
      destinationId: place.id,
      url: `/search/homes-and-villas?${queryParams}`,
    }
  }), [filters])
}
